import './instagram-button.css'
import './static/instagram.svg'
